import './App.css';
import Temp from './Components/Temp';
function App() {
  return (
    <div className="App">
      <Temp />
    </div>
  );
}

export default App;
